import {
  call,
  put,
  takeLatest
} from "redux-saga/effects";
import {
  authorizedRequest
} from "utils/api";
import {
  API_ROLES
} from "constants/apiRoutes";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

export const ROLE_FETCH_REQUEST = "ROLE_FETCH_REQUEST";
export const ROLE_FETCH_SUCCESS = "ROLE_FETCH_SUCCESS";
export const ROLE_FETCH_FAILURE = "ROLE_FETCH_FAILURE";

const initialState = [];

export default function roleReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case ROLE_FETCH_SUCCESS:
      return [...payload.roles];

    default:
      return state;
  }
}

/**
 * Get all roles
 * @return {Object} Action
 */
export function fetchRoles() {
  return {
    type: ROLE_FETCH_REQUEST
  };
}

export function roleFetchSuccess(payload) {
  return {
    type: ROLE_FETCH_SUCCESS,
    payload
  };
}

function roleFetchFailure(payload) {
  return {
    type: ROLE_FETCH_FAILURE,
    payload
  };
}

// Saga
function* fetchSaga() {
  try {
    const response = yield call(authorizedRequest, API_ROLES);
    yield put(roleFetchSuccess(response));
  } catch (error) {
    yield put(roleFetchFailure(error));
    ToastError(error.message);
  }
}

export function* roleSaga() {
  yield takeLatest(ROLE_FETCH_REQUEST, fetchSaga);
}
